import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { displayAccountLabel } from "@common/helpers/accounting";
import { fullDateLongFormat } from "@common/helpers/date";
import { formatBusinessDate, formatDateOnly } from "@helpers/date";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useShowAccountNumbers } from "@hooks/useShowAccountNumbers";
import { GLViewRow } from "../glViewTypes";
import styles from "../GeneralLedgerTable.module.scss";

export const GLNameCell = React.memo(function GLNameCell({
    row,
}: CellContext<ViewTableFeatures, GLViewRow, unknown>): React.ReactElement {
    const { rowKind, account, transaction } = row.original;
    const showAccountNumbers = useShowAccountNumbers();

    if (rowKind === "account" && account) {
        return (
            <ViewTableCell className={styles.accountCell}>
                {displayAccountLabel(account, showAccountNumbers)}
            </ViewTableCell>
        );
    }
    if (rowKind === "openingBalance") {
        return (
            <ViewTableCell className={styles.balanceLabelCell}>
                Beginning Balance
            </ViewTableCell>
        );
    }
    if (rowKind === "closingBalance") {
        return (
            <ViewTableCell className={styles.endingBalanceLabelCell}>
                Ending Balance
            </ViewTableCell>
        );
    }
    if (rowKind === "transaction" && transaction) {
        return (
            <ViewTableCell className={styles.transactionCell}>
                {"dateOnly" in transaction && transaction.dateOnly
                    ? formatDateOnly(transaction.dateOnly, fullDateLongFormat)
                    : formatBusinessDate(transaction.date, fullDateLongFormat)}
            </ViewTableCell>
        );
    }
    return <ViewTableCell />;
});
